<template>
    <div id="topo" class="topo">
        <div class="div-voltar" v-if="exibeVoltar" @click="voltar">
            <i class="fas fa-arrow-left"></i>
        </div>

        <center>
            <img  v-if="!title" id="logo" class="logo"  src="../../assets/logocor.png" height="60px"><br/>

            <div v-if="!subtitle" class="top-bar-title">
                <span v-if="title">{{ title }}</span>
            </div>
            <div v-if="subtitle" class="top-bar-title div-subtitle">
                <span v-if="title">{{ title }}</span>
                <span v-if="subtitle" class="subtitle"><br/>{{ subtitle }}</span>
            </div>

        </center>
        
        <div class="div-btn" v-if="title">
            <button class="menu-btn" id="menu_btn" aria-label="Toggle menu" @click="toggle()">
                <i class="menu-btn-icon" id="menu_btn_i" data-toggle="false" aria-hidden="true"></i>
            </button>
        </div>


        <div class="menu" data-status="oculto">
            <center>
                <br/><img src="../../assets/logocor.png" height="60px"><br/><br/>
            </center>

            <div>

                <button @click="cadastros"                        
                   class="menu-btn-oculto">
                    <i class="far fa-address-card fa-lg nav-awesome"></i>Cadastros
                </button>

                <button @click="financeiro"                        
                   class="menu-btn-oculto">
                    <i class="fas fa-hand-holding-usd fa-lg nav-awesome"></i>Financeiro
                </button>

                <button @click="lembretes"                        
                   class="menu-btn-oculto">
                    <i class="far fa-clock fa-lg nav-awesome"></i>Lembretes
                </button>
                <br/><br/><br/>

                <button @click="sair"                        
                   class="menu-btn-oculto">
                    <i class="fas fa-lg fa-power-off texto-vermelho"></i>Sair
                </button>

            </div>
        </div>

        <div class="block-menu"></div>

        
        <login-expirado/>
        <load-mask  v-if="title"/>
        
    </div>
</template>

<script>
import LoadMask from '@/views/LoadMask.vue';
import LoginExpirado from '@/views/LoginExpirado.vue';

export default {
    name : 'TopBar',
    props: ['title','subtitle','exibeVoltar','navigateto', 'historyback','home'],
    components: {LoadMask, LoginExpirado},

    mounted(){    
        
        if (this.title){
            document.getElementById('topo').style.height = '55px';

        } else {
            document.getElementById('topo').style.height = '190px';
        }
    },

    methods: {

        ajustaPosicaoLogo(campo){

            if (campo=='login')
            document.getElementById('topo').style.marginTop = '-30px'; else
            
            if (campo=='senha')
            document.getElementById('topo').style.marginTop = '-60px'; else

            document.getElementById('topo').style.marginTop = '0px';

            
        },
        toggle(){
            var element = document.getElementById('menu_btn_i');
            
            if (element.dataset.toggle=="true"){
                element.dataset.toggle="false";
                element.classList.remove('menu-btn-icon-toggle');
                element.classList.add('menu-btn-icon');			
            } else {
                element.dataset.toggle="true";
                element.classList.add('menu-btn-icon-toggle');
                element.classList.remove('menu-btn-icon');
            }

            let menu = document.getElementsByClassName('menu')[0];
            let block = document.getElementsByClassName('block-menu')[0];
            
            if(menu.dataset.status==="oculto"){
                menu.style.left="0px";
                menu.dataset.status="visivel";
                
                Object.assign(block.style, {
                    visibility: "visible", opacity:1, pointerEvents: "all"
                });					
                
            } else if(menu.dataset.status==="visivel"){
                menu.style.left="-308px";
                menu.dataset.status="oculto";
                
                Object.assign(block.style, {
                    visibility: "hidden", opacity:0, pointerEvents: "none"
                });	
                
            }	

        },
        voltar(){

            if(this.historyback=="true"){
                history.back(1); 
            }

            if(this.navigateto)
            this.$emit('navigate', this.navigateto);          
               
        },
        cadastros(){
            this.toggle();
            this.$router.push('/cadastros');
            
            if(this.isTelaHome())
            this.$emit('navigate', 'cadastros');
        },
        financeiro(){
            this.toggle();
            this.$router.push('/financeiro');

            if(this.isTelaHome())
            this.$emit('navigate', 'financeiro');
        },
        lembretes(){
            this.toggle();
            this.$router.push('/lembretes');
            
            if(this.isTelaHome())
            this.$emit('navigate', 'lembretes');
        },

        isTelaHome(){

            return this.home;
            /*
            return ((this.title.toLowerCase()=='cadastros') ||
                (this.title.toLowerCase()=='financeiro') ||
                (this.title.toLowerCase()=='lembretes'));*/
        },

        sair(){
            this.toggle();

            if(confirm('Tem certeza que deseja sair ?')){
                this.$root.setSessao('');
                this.$router.push('/');
            }

        }
                   

    }

}
</script>

<style scoped>
    .div-voltar{
        width: 30px;
        margin-left: 20px;
        float: left;
        color: white;
        font-size: 20px;
        line-height: 55px;
        margin-right: -50px; 
    }

    .div-btn{
        width: 48px;
        height: 50px;
        float: right;
        color: white;
        margin-top: -12px;
        z-index: 10;
       
        right: 5px;

        position: fixed;
        z-index: 20;
        display: table;

    }

    .top-bar-title{
        width: calc(100% - 90px);
        float: left;
        margin-left: 40px;
        font-size: 18px;
        line-height: 18px;
    }


    .div-subtitle{
        margin-top: -8px;
    }

    .subtitle{
        font-size: 14px;
    }


    .menu-btn-oculto{
        background-color: Transparent;
        background-repeat:no-repeat;
        outline: none;
        border: 0px;
        color: white;
        width: calc(100% - 20px);
        margin: 5px 0;
        font-size: 18px;
        text-align: left;  
        height: 50px;
        
    }

	.menu-btn {
		display: flex;
        justify-content: center;
        outline: none;

		align-items: center;
		height: 36px;
		width: 36px;
		padding: 0px;
		background-color: transparent;
		border: 0px solid;
		outline: none;
		cursor: hand;
		border-radius: 5px;
		transform: scale(1);
		transition: transform 1.2s, background-color .3s linear;
	}

	.menu-btn-icon, .menu-btn-icon-toggle{
		display: block;
		position: relative;
		width: 25px;
		height: 2px;
		color: white;
		background-image: linear-gradient(white, white);
		background-repeat: no-repeat;
		background-size: 100% 100%;
		transform: scale(1);
		transition: transform 0.2s, background-size 0.2s;
	}

		
	.menu-btn-icon::before, .menu-btn-icon::after, .menu-btn-icon-toggle::before, .menu-btn-icon-toggle::after{
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-image: inherit;
		transition: inherit;
	}
	
	.menu-btn-icon::before{
		transform: translateY(-8px) rotate(0);
	}
	
	.menu-btn-icon::after{
		transform: translateY(8px) rotate(0);
	}
	
	.menu-btn-icon-toggle{
		transform: translateY(0px) rotate(225deg);
		--transform: translateY(0px) rotate(45deg);
	}	
	
	
			
	.menu-btn-icon-toggle::after{
		transform: translateY(0px) rotate(270deg);		
		--transform: translateY(0px) rotate(-90deg);
	}
		
	
	.menu-btn:hover {
		--background-color: #F00;
		--transform: scale(1.1);
    }
    
    .menu{
        position: fixed;
        top: 0px;
        left: -308px;
        width: 304px;
        height: calc(100% - 4px);
        background-image: linear-gradient(var(--dark-color), #2384e3);
        -webkit-transition: all 0.5s; /* Safari prior 6.1 */
        transition: all 0.5s;	
        z-index: 15;
        --border: 2px solid #7bb835;
    }

    .menu div{
        line-height: 30px;
        --font-size: 30px;
        color: white;
        height: 30px;
        padding: 10px;
        margin-left: 20px;
    }
    
    .menu div i{

        margin-right: 10px;

    }    
          
    .texto-vermelho{
        color: red;
    }


	
</style>